import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';

import { useSidebarStore } from '@/shared/components/layout/_useSidebarStore';

/**
 * 안드로이드 하드웨어/제스처 뒤로가기 처리.
 * 우선순위: 열린 드로어 닫기 → 웹 히스토리 뒤로 → (히스토리 없으면) 앱 종료.
 * iOS엔 뒤로가기 버튼이 없어 리스너가 호출되지 않는다.
 */
export function useAndroidBackButton() {
  useEffect(() => {
    if (Capacitor.getPlatform() !== 'android') return;

    const handle = CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      const { isMobileDrawerOpen, setMobileDrawerOpen } = useSidebarStore.getState();

      if (isMobileDrawerOpen) {
        setMobileDrawerOpen(false);
        return;
      }

      if (canGoBack || window.history.length > 1) {
        window.history.back();
        return;
      }

      CapacitorApp.exitApp();
    });

    return () => {
      handle.then((h) => h.remove());
    };
  }, []);
}
